<div class="mc-spring-board">
  <div class="mc-spring-board-body">
    <mc-publication-progress-bar [publication]="publication"></mc-publication-progress-bar>

    <div class="mc-publication-overview-timeline-header">
      <div>Queued</div>
      <div>Started</div>
      <div>Finished</div>
    </div>

    <div class="mc-publication-overview-timeline">
      <mat-icon fontSet="project-titan" fontIcon="icon-dot-circle" class="mc-text-muted"></mat-icon>
      <mat-divider></mat-divider>
      <mat-icon fontSet="project-titan" fontIcon="icon-dot-circle" class="mc-text-muted"></mat-icon>
      <mat-divider></mat-divider>
      <mat-icon fontSet="project-titan" fontIcon="icon-dot-circle" class="mc-text-muted"></mat-icon>
    </div>

    <div class="mc-publication-overview-timeline-footer">
      <div>{{ publication.CreatedOn | date: 'MMM dd, yyyy h:mm a' }}</div>
      <div>{{ publication.Process?.LastProcessAttempt?.CreatedOn | date: 'MMM dd, yyyy h:mm a' }}</div>
      <div>
        <ng-container *ngIf="publication.IsStopped">
          {{ publication.Process?.LastProcessAttempt?.EndedOn | date: 'MMM dd, yyyy h:mm a' }}
        </ng-container>
      </div>
    </div>

    <div class="mc-publication-overview-avatars">
      <div class="mc-publication-overview-avatar-container mc-avatar-grid">
        <b class="mc-publication-overview-header">Queued by</b>
        <mc-license-user-avatar *ngIf="creatorLicenseUser$ | async as creatorLicenseUser; else noCreator" [licenseUser]="creatorLicenseUser" size="small" [truncate]="true"></mc-license-user-avatar>
        <ng-template #noCreator>
          <mc-flare-online-avatar name="Scheduler" size="small"></mc-flare-online-avatar>
        </ng-template>
      </div>

      <div class="mc-publication-overview-avatar-container mc-avatar-grid">
        <b class="mc-publication-overview-header">Build</b>
        <mc-build-avatar [build]="publication.Build" size="small" [truncate]="true"></mc-build-avatar>
      </div>

      <div class="mc-publication-overview-avatar-container mc-avatar-grid">
        <b class="mc-publication-overview-header">Project</b>
        <mc-project-avatar [project]="project$ | async" size="small" [truncate]="true"></mc-project-avatar>
      </div>

      <div class="mc-publication-overview-avatar-container mc-avatar-grid">
        <b class="mc-publication-overview-header">Target</b>
        <mc-target-avatar size="small" [branchName]="publication.Build?.BranchName" [project]="project$ | async" [targetPath]="publication.Build?.TargetPath" [truncate]="true"></mc-target-avatar>
      </div>

      <div class="mc-publication-overview-avatar-container mc-avatar-grid">
        <b class="mc-publication-overview-header">Branch</b>
        <mc-branch-avatar [branchName]="publication.Build?.BranchName" [project]="project$ | async" size="small" [truncate]="true"></mc-branch-avatar>
      </div>

      <div class="mc-publication-overview-avatar-container mc-avatar-grid">
        <b class="mc-publication-overview-header">Commit ID</b>
        <mc-commit-avatar [commit]="publication.Build?.CommitId ? publication.Build?.CommitId : 'Unknown'" size="small" [truncate]="true"></mc-commit-avatar>
      </div>

      <ng-container *ngIf="destination$ | async as destination">
        <div class="mc-publication-overview-avatar-container mc-avatar-grid">
          <b class="mc-publication-overview-header">Destination</b>
          <mc-destination-avatar [destinationPath]="publication.DestinationFilePath" [destinationType]="destination.Type" [branchName]="publication.Build?.BranchName" [project]="project$ | async" size="small" [truncate]="true"></mc-destination-avatar>
        </div>

        <div class="mc-publication-overview-text-container">
          <b class="mc-publication-overview-header">Host</b>
          <p class="mc-truncate" [matTooltip]="destination.Host">{{ destination.Host }}</p>
        </div>

        <div class="mc-publication-overview-text-container">
          <b class="mc-publication-overview-header">{{ destination.Type == 'syndicate' ? 'Folder' : 'Directory' }}</b>
          <p class="mc-truncate" [matTooltip]="destination.Type == 'syndicate' ? destination.Folder : destination.Directory">{{ destination.Type == 'syndicate' ? destination.Folder : destination.Directory }}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>